import { useTranslation } from "@opendash/i18n";
import { Form, FormItemProps, Input } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { SaveTicketValues } from "../../..";
import { useFieldConfig } from "../../hooks/useFieldConfig";

type Props = {} & FormItemProps<SaveTicketValues>;

export const TitleInput = observer((props: Props) => {
  const t = useTranslation();
  const config = useFieldConfig("title");

  if (config && config.hidden) return <></>;

  const placeholder =
    config?.placeholder === "-"
      ? ""
      : config?.placeholder || t("maintenance:ticket.create.title.placeholder");

  const label =
    config?.label === "-"
      ? ""
      : config?.label || t("maintenance:ticket.create.title.label");

  return (
    <Form.Item<SaveTicketValues>
      name="title"
      label={label}
      help={config?.help}
      rules={[
        {
          required: config?.required,
          message: t("maintenance:ticket.create.title.error.empty"),
        },
      ]}
      {...props}
    >
      <Input placeholder={placeholder} />
    </Form.Item>
  );
});
